import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['dateHeading']

  removeDuplicateDateHeadings() {
    let prevHeading = ''

    this.dateHeadingTargets.forEach((heading) => {
      if (heading.textContent === prevHeading) {
        heading.remove()
      } else {
        prevHeading = heading.textContent
      }
    })
  }
}
